// D-MAJ-RECHARGEMENT : vrai si la version publiee (version.json, ecrit au build) differe de celle de cet onglet.
// Echec reseau ou fichier absent : faux, la verification suivante retentera.
export async function nouvelleVersionEnLigne(): Promise<boolean> {
  try {
    const reponse = await fetch('/version.json', { cache: 'no-store' });
    if (!reponse.ok) return false;
    const { version } = (await reponse.json()) as { version?: string };
    return !!version && version !== __APP_VERSION__;
  } catch {
    return false;
  }
}
